import EventsIndex from "./EventsIndex";
export default EventsIndex;
